import { styled } from 'styled-components';

export const SAgeGroupItemMultyplier = styled.span`
  font-size: 12px;
  font-weight: 700;
`;
